/** Keep in sync with the boot script in `index.html` (same key string). */
export const COLOR_SCHEME_STORAGE_KEY = 'mx-color-scheme';

export type ColorScheme = 'light' | 'dark';

export function readStoredColorScheme (): ColorScheme {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return 'light';
  }
  try {
    const v = window.localStorage.getItem(COLOR_SCHEME_STORAGE_KEY);
    if (v === 'dark' || v === 'light') {
      return v;
    }
  } catch {
    /* private mode / denied */
  }
  return 'light';
}

export function applyColorSchemeClass (scheme: ColorScheme): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.classList.toggle('dark', scheme === 'dark');
}
